export default __webpack_public_path__ + "static/media/previous.d61ff6d3.svg";